import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory, createHashHistory } from "history";

import * as serviceWorker from "./serviceWorker";
import configureStore from "./configureStore";
import { VhTools } from "msd";
import App from "./App";
import "./index.scss";

import * as Sentry from "@sentry/react";
import pkg from "../package.json";

process.env.REACT_APP_ENV !== "pro" && Sentry.init({
    enabled: true,
    dsn: "https://915d55d3db2d428eb80d62bf8a2f8535@o4505503889293312.ingest.sentry.io/4505520722542592",
    integrations: [
        new Sentry.BrowserTracing({}),
        new Sentry.Replay(),
    ],
    environment: process.env.REACT_APP_ENV,
    // 用于性能监控
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysOnErrorSampleRate: 1.0,
    release: pkg.version
});

// 创建browser history对象，router和redux连接必须传递
const history = VhTools.supportsHistory() ? createBrowserHistory() : createHashHistory();
// 从window对象中获取初始state
const initialState = (window as any).initialReduxState;
// 配置store
const store = configureStore(history, initialState);

// 渲染根组件，传入store和history属性
ReactDOM.render(
  <App store={store} history={history} />,
  document.getElementById("root") as HTMLElement
);
serviceWorker.unregister();
